import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PlayBlocksLogsIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#7985a3' : this.getColor()
        return [
            <g transform="translate(0.75 0.75)">
                <path d="M13.166,1.714h2.176a1.451,1.451,0,0,1,1.451,1.451V15.833a1.451,1.451,0,0,1-1.451,1.451H3.736a1.451,1.451,0,0,1-1.451-1.451V3.165A1.451,1.451,0,0,1,3.736,1.714H5.912" transform="translate(-2.286 -0.264)" fill="none" stroke="#7985a3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <rect width="7.253" height="3.627" rx="1.143" transform="translate(3.627)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" stroke-width="1.5"/>
                <line x2="7.253" transform="translate(3.627 8.258)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
                <path d="M0,0H3.575" transform="translate(3.627 11.788)" fill="none" stroke={color} strokeLinecap="round" strokeWidth="1.5"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 16.007 18.52'
}
